// src/components/layout/Navbar.jsx
import { useEffect, useState } from "react";
import { siteMeta } from "../../data/siteContent";

export default function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header className={`navbar ${scrolled ? "navbar--scrolled" : ""}`}>
      <div className="navbar__inner container-shell">
        <a href="#hero" className="navbar__brand">
          <img src={siteMeta.logo} alt="Dryvziro" className="navbar__logo" />
        </a>

        <nav className={`navbar__links ${menuOpen ? "is-open" : ""}`}>
          <a href="#hero" onClick={() => setMenuOpen(false)}>
            About
          </a>
          <a href="#model" onClick={() => setMenuOpen(false)}>
            Model
          </a>
          <a href="#impact" onClick={() => setMenuOpen(false)}>
            Impact
          </a>
          <a href="#portfolio" onClick={() => setMenuOpen(false)}>
            Portfolio
          </a>
          <a href="#technology" onClick={() => setMenuOpen(false)}>
            Technology
          </a>
          <a href="#contact" onClick={() => setMenuOpen(false)}>
            Contact
          </a>
        </nav>

        <div className="navbar__actions">
          <a
            className="btn btn--primary"
            href={siteMeta.ctaHref}
            target="_blank"
            rel="noreferrer"
          >
            {siteMeta.ctaLabel}
          </a>

          <button
            className="navbar__toggle"
            type="button"
            onClick={() => setMenuOpen((prev) => !prev)}
            aria-label="Toggle navigation"
          >
            <span />
            <span />
          </button>
        </div>
      </div>
    </header>
  );
}
